export default function Archived() {
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #EFF2F3", backgroundColor: "#F6F9F9" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/archive.svg" alt="" />
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#474C4D", fontWeight: "700" }}>Archived</span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {" "}
        The proposal is now in history.{" "}
      </h6>
    </div>
  );
}
